import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import { IDishAssignmentContext, DishAssignmentContext } from '../../../../dishAssignmentState/dishAssignmentContext';
import { Dish } from './components/Dish';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Dishes.module.scss';

export const Dishes: React.FC = () => {
	const { setIDsSelectedSubcategories, IDsSelectedSubcategories, searchStringForDishes, dishes } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const filteredDishes = useMemo(() => {
		if (searchStringForDishes) {
			const updatedDishes = dishes.map((el) => {
				const filteredDishByName = el.dishes.filter((dish) =>
					dish.name?.toLowerCase().includes(searchStringForDishes.toLowerCase()),
				);
				const filteredDishByExternalId = el.dishes.filter((dish) =>
					dish.externalId?.toLowerCase().includes(searchStringForDishes.toLowerCase()),
				);
				const unionFilteredData = Array.from(new Set([...filteredDishByName, ...filteredDishByExternalId]));
				return { ...el, dishes: unionFilteredData };
			});
			return updatedDishes;
		}
		return dishes;
	}, [searchStringForDishes, dishes]);

	const changeCloseStatus = (subcategoryID: string) => {
		const copyIDsSelectedSubcategories = { ...IDsSelectedSubcategories };
		copyIDsSelectedSubcategories[subcategoryID] = !copyIDsSelectedSubcategories[subcategoryID];
		setIDsSelectedSubcategories(copyIDsSelectedSubcategories, false);
	};

	const deleteSubcategory = (subcategoryID: string) => {
		const copyIDsSelectedSubcategories = { ...IDsSelectedSubcategories };
		delete copyIDsSelectedSubcategories[subcategoryID];
		setIDsSelectedSubcategories(copyIDsSelectedSubcategories, true);
	};

	return (
		<div data-test="Dishes">
			{filteredDishes.map((el) => {
				const wrapperClasses = classNames(style.wrapper, {
					[style.collapsedWrapper]: !IDsSelectedSubcategories[el.id],
				});

				return (
					<div key={el.id + 'mainDisplayDishesTab'}>
						<div className={wrapperClasses}>
							<div className={style.category}>
								<div className={style.name} onClick={() => changeCloseStatus(el.id)}>
									<Text
										translationKey={el.name}
										theme={!IDsSelectedSubcategories[el.id] ? 'secondary' : 'contrast'}
										withTooltip={true}
									/>
									<svg className={style.pointerIcon}>
										<use xlinkHref={`${breadcrumbs}#next`} />
									</svg>
								</div>
								<svg className={style.closeIcon} onClick={() => deleteSubcategory(el.id)}>
									<use xlinkHref={`${breadcrumbs}#close`} />
								</svg>
							</div>
							<div className={style.subcategory}>
								{el.dishes.length ? (
									<Dish data={el.dishes} subcategoryID={el.id} />
								) : (
									<Text
										className={style.notification}
										translationNameSpace="listing"
										translationKey="noDishesLabel"
										theme="errorDark"
										weight="bold"
										align="center"
									/>
								)}
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};
